import axios from '@/axios.js'

export default {
  getCashFlow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/cashflow?cashbook_id=${payload.cashbookID}&per_page=${payload.perPage}&page=${payload.page}&search=${payload.search}&type=${payload.type}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  findCashFlow (context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/cashflow/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createCashFlow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v1/cashflow', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCashFlow (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/v1/cashflow/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteCashFlow (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/v1/cashflow/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
